import { api } from 'utils';

import {
  DirectClaimsParams,
  FetchDirectClaimsApiResponse,
} from './DirectClaims.types';

export function fetchDirectClaimsApi({ queryKey }: any) {
  const [, , params] = queryKey as [string, string, DirectClaimsParams];

  return api().get<FetchDirectClaimsApiResponse>(
    '/endorsement/health-claims/direct',
    {
      params: {
        startDate: params.startDate,
        // Sent only when set, so an empty box is no filter rather than a
        // filter on the empty string.
        endDate: params.endDate || undefined,
        category: params.category,
        referenceNumber: params.referenceNumber || undefined,
        referenceType: params.referenceType || undefined,
        middleName: params.middleName || undefined,
      },
    }
  );
}
